import { InformationOffIcon } from './InformationOffIcon';

/**
 * author: Michael Irigoyen
 * id 68E3EA61-207C-444B-9CC5-8A7016D9953C
 * name information-off
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-off.svg
 * tags
 */
export const InformationCircleOffIcon = InformationOffIcon;
export default InformationCircleOffIcon